// extracted by mini-css-extract-plugin
export default {"cls1":"bqOLXySp4d9W93DtTnYa","cls2":"FyUYBBuUwSy8qrXmFjPf bqOLXySp4d9W93DtTnYa"};